module.exports = __webpack_public_path__ + "static/media/screenshot-4.7d78bb51.png";